export default __webpack_public_path__ + "ba9684bdc9a5096c66da38a228968305.png";